import { ArvResponse, MemberData } from 'hooks/transformToJson'
import { PersonalDataType } from 'shared_components/FormPersonalData'
import PersonalDataApi from './PersonalDataApi'

export interface PersonalDataServiceInterface {
    updatePersonalData: (
        personalData: PersonalDataType,
        memberData: MemberData,
        allMemberData: MemberData | MemberData[] | undefined,
        user: string,
        token: string,
    ) => Promise<ArvResponse>
}

class personalDataService {
    public updatePersonalData = async (
        personalData: PersonalDataType,
        memberData: MemberData,
        allMemberData: MemberData | MemberData[] | undefined,
        user: string,
        token: string,
    ): Promise<ArvResponse> => {
        return await PersonalDataApi.updatePersonalData(personalData, memberData, allMemberData, user, token)
    }
}

export default new personalDataService()
